export default __webpack_public_path__ + "static/media/login-nofish.8e7cee2c.jpg";